import { Checkbox, Form } from 'antd';
import { useRef } from 'react';

const packageWeightMeasuresFields = [
  'width',
  'height',
  'depth',
  'weight',
  'weightUOM',
  'dimensionUOM',
];

export const VariableWeightsAndMeasures = (props) => {
  const form = Form.useFormInstance();

  const previousErrors = useRef({});

  const { productData, isProductOverlay } = props;

  const handleUpdateWeightError = (isCheckedWeightsAndMeasure) => {
    const fieldsToUpdate = packageWeightMeasuresFields.map((fieldName) => {
      const fieldError = form.getFieldError(fieldName);
      const fieldValue = form.getFieldValue(fieldName);

      // If field has a value, clear its errors
      if (fieldValue) {
        return {
          name: fieldName,
          errors: [],
        };
      }

      // Handle checkbox state changes
      if (isCheckedWeightsAndMeasure) {
        // Save current error and clear it
        previousErrors.current[fieldName] = fieldError;
        return {
          name: fieldName,
          errors: [],
        };
      } else {
        // Restore previous error
        return {
          name: fieldName,
          errors: previousErrors.current[fieldName] || [],
        };
      }
    });

    form.setFields(fieldsToUpdate);
  };

  const handleChangeVariableWeightsAndMeasures = (e) => {
    const isCheckedWeightsAndMeasure = e.target.checked;

    handleUpdateWeightError(isCheckedWeightsAndMeasure);

    const formValues = form.getFieldsValue();
    const formValuesResult = {
      ...formValues,
      weight: isCheckedWeightsAndMeasure ? null : productData?.weight,
      averageWeight: isCheckedWeightsAndMeasure
        ? productData?.averageWeight
        : null,
    };
    form.setFieldsValue(formValuesResult);
  };

  return (
    <Form.Item
      label='Variable Weights and Measures'
      name='isVariableWeightsAndMeasures'
      valuePropName='checked'
      colon={false}
      labelCol={{
        flex: 'auto',
      }}
      wrapperCol={{
        flex: 'auto',
      }}
    >
      <Checkbox
        onChange={handleChangeVariableWeightsAndMeasures}
        disabled={isProductOverlay}
      />
    </Form.Item>
  );
};
